import { render, staticRenderFns } from "./TransactionEdit.vue?vue&type=template&id=b6bb91ca&"
import script from "./TransactionEdit.vue?vue&type=script&lang=js&"
export * from "./TransactionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6bb91ca')) {
      api.createRecord('b6bb91ca', component.options)
    } else {
      api.reload('b6bb91ca', component.options)
    }
    module.hot.accept("./TransactionEdit.vue?vue&type=template&id=b6bb91ca&", function () {
      api.rerender('b6bb91ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/transactions/TransactionEdit.vue"
export default component.exports